import { type ComponentPropsWithoutRef, forwardRef } from 'react';

import { cn } from '~/shared/utils/cn';

export const Overlay = forwardRef<
  HTMLDivElement,
  ComponentPropsWithoutRef<'div'>
>(({ className, ...rest }, ref) => (
  <div
    ref={ref}
    className={cn(
      'fixed inset-0 z-1300 h-full w-full bg-[rgba(0,0,0,0.44)]',
      className
    )}
    {...rest}
  />
));
Overlay.displayName = 'Overlay';
